module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-d-inline"
  }, [_c('header-section', {
    attrs: {
      "title": "BC Legal - ABC Quantum",
      "set-position": "relative",
      "set-width": "100"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-content ie",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "p-homepage__content flex-grid"
  }, [_c('div', {
    staticClass: "p-homepage__object flex-grid__g-3"
  }, [_c('div', {
    staticClass: "a-logo-image--homepage"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 400 53.8"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#logo"
    }
  })])]), _vm._v(" "), _vm._m(0), _c('br'), _vm._v("\n    \n                The most comprehensive quantum calculator for all types of occupational disease & personal injury claims — including fatal claims, lost years claims & those of utmost severity.\n            ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "p-homepage__policies"
  }, [_c('modal-in-the-wild', {
    attrs: {
      "modal-name": "homepage_cookie_policy"
    }
  }, [_c('p', {
    staticClass: "c-modal-in-the-wild"
  }, [_vm._v("Cookie Policy")])]), _vm._v("\n\n            |\n\n            "), _c('modal-in-the-wild', {
    attrs: {
      "modal-name": "homepage_disclaimer"
    }
  }, [_c('p', {
    staticClass: "c-modal-in-the-wild"
  }, [_vm._v("Disclaimer")])]), _vm._v("\n\n            |\n\n            "), _vm._m(3), _vm._v("\n\n            |\n\n            "), _vm._m(4), _vm._v("\n\n            |\n\n            "), _vm._m(5)], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "homepage_disclaimer",
      "no-default-button": "true"
    }
  }, [_c('disclaimer')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "homepage_cookie_policy",
      "no-default-button": "true"
    }
  }, [_c('cookie-policy')], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("Welcome to the"), _c('br'), _vm._v(" "), _c('b', [_vm._v("ABC Quantum Tool")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-homepage__object flex-grid__g-7 u-no-margin v-image"
  }, [_c('img', {
    attrs: {
      "src": "static/video/mockup.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-homepage__object flex-grid__g-7 u-no-margin v-video"
  }, [_c('video', {
    attrs: {
      "id": "video",
      "src": "static/video/quantum.mp4",
      "type": "video/mp4",
      "controls": ""
    }
  }, [_vm._v("\n                Sorry, your browser doesn't support embedded videos, \n                but don't worry, you can "), _c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("download it")]), _vm._v("\n                and watch it with your favorite video player!\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://quantum.internal.bc-legal.co.uk/api/v1/licenses/security-policy.pdf",
      "target": "_blank"
    }
  }, [_c('p', {
    staticClass: "c-modal-in-the-wild"
  }, [_vm._v("Security Policy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://quantum.internal.bc-legal.co.uk/api/v1/licenses/privacy-policy.pdf",
      "target": "_blank"
    }
  }, [_c('p', {
    staticClass: "c-modal-in-the-wild"
  }, [_vm._v("Privacy Policy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://quantum.internal.bc-legal.co.uk/api/v1/licenses/license-agreement.pdf",
      "target": "_blank"
    }
  }, [_c('p', {
    staticClass: "c-modal-in-the-wild"
  }, [_vm._v("License Agreement")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2d25ea40!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Homepage.vue
// module id = 1622
// module chunks = 0